import { SliderField } from './SliderField';
import type { StylingProps } from '@builder4/shared/types/layout';
import { useInspectorNode } from '@/hooks/useInspectorNode';
import { useBreakpointAwareProp } from '@/hooks/useBreakpointAwareProp';

interface StrokeProps {
  borderWidth: number;
}

const NodeStrokeSettings = ({ max = 100 }: { max?: number }) => {
  const { id, props, node, actions } = useInspectorNode<StrokeProps>();

  const { setBPProp, getBPProp } = useBreakpointAwareProp(node?.data.displayName || 'Unknown');

  const borderWidth = getBPProp(props, 'borderWidth');

  const updateStroke = (value: number, skipHistory = false) => {
    const actionMethod = skipHistory ? actions.history.ignore().setProp : actions.setProp;
    actionMethod(id, (props: StylingProps) => {
      setBPProp(props, 'borderWidth', value);
    });
  };

  const handleOnChangeStroke = (e: number) => {
    updateStroke(e, true);
  };

  const handleOnChangeStrokeComplete = (value: number, initialValue: number) => {
    updateStroke(initialValue, true);
    updateStroke(value);
  };

  return (
    <SliderField
      label="Stroke"
      value={borderWidth}
      onChange={handleOnChangeStroke}
      onChangeComplete={handleOnChangeStrokeComplete}
      min={0}
      max={max}
    />
  );
};

export default NodeStrokeSettings;
